import { useEffect, useMemo, useState } from 'react'
import TwilioIntegrationForm from '../../../Pages/ivr/TwilioIntegrationForm'
import GlobalCallModal from '../../../Pages/ivr/GlobalCallModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons'
import Tooltip from '@mui/material/Tooltip'
import { Container, Dropdown, Nav, Table } from 'react-bootstrap'
import { toast } from 'sonner'
import { checkTwilioIntegration, downloadCSV, fetchTemporaryFilterData, formatDate, formatTime, maskContactNumber, navigateToCrmDetail } from '../../../Utils/helpers/commonhelper'
import { TableWrapper } from '../../TableWrapper'
import { PostRequest } from '../../../Utils/hooks/ApiHandler'
import { BulkUpdateModal } from '../../BulkUpdateModal'
import useCommonData from '../../../Utils/actions/advanceFilteringAction'
import DeleteModal from "../../../Pages/DeleteModal"
import { useGetEssentials } from '../../../Utils/hooks/useGetEssentials'
import { useLocation } from 'react-router-dom'
import { WhatsappModal } from '../../WhatsappModal'
import { EmailModal } from '../../../Pages/detailPage/leads/EmailModal'

export const KanbanTableListing = ({
    data,
    visibleColumns,
    tempFilterData,
    filteredLeads,
    canEdit_canDownload,
    // dataToDisplay,
    // pageCount,
    limit,
    setLimit,
    offset,
    setOffset,
    highlightId,
    onDeleteLead,
    onEditLead,
    onOpenLeadDetails,
    module_name,
    handlePageChange,
    totalModuleDataCount,
    isDataLoading,
    filterDropPipelineStage,
    pipeline_id,
    refetchData,
    mainGrant,
    currAdvFilter,
    applyFilterDataParams,
    tempFilterDataLoading
}) => {

    const { customer, headers, extras, loginUserId, customerId, navigate } = useGetEssentials()
    const location = useLocation()
    const detailPagePath = module_name === "lead" ? "/leadDetails" : "/dealDetails";

    // to track which row's dropdown is open
    const [openRow, setOpenRow] = useState(null)

    // dialer states for twilio
    const [callingTo, setCallingTo] = useState(null)
    const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
    const [globalDiller, setGlobalDiller] = useState(false);
    const [showtwilioModal, setShowTwilioModal] = useState(false);
    const [module_id, setModuleId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [showWhatsappModal, setShowWhatsappModal] = useState(false)
    const [showEmailModal, setShowEmailModal] = useState(false)
    // state for bulk updating and perform multiple actions on selected items
    const [showMultiItemChangeBar, setShowMultiItemChangeBar] = useState(false)
    // state for bulk Update modal
    const [showBulkUpdateModal, setShowBulkUpdateModal] = useState(false)

    // state for storing the selected items
    const [selectedItems, setSelectedItems] = useState([])
    // state for storin the bulk update field
    const [fieldData, setFieldData] = useState(null)
    const { leadOwner } = useCommonData({
        leadOwner: true,
        lead_source: false,
        company: false,
        contacts: false
    })
    //  column options for bulk updatesnp
    const bulkUpdateColumns = [
        { value: "owner_id", label: "Owner", option: leadOwner || [] },
        { value: "pipeline_stage_id", label: "Pipeline Stage", option: filterDropPipelineStage || [] },
        { value: "closure_date", label: "Expected Closure Date", type: "date-range" },
        { value: "followup_date", label: "Next FollowUp Date", type: "date-range" },
        // {
        //     value: "priority", label: "Priority", option: [
        //         { value: 'high', label: "High" },
        //         { value: 'medium', label: "Medium" },
        //         { value: 'low', label: "Low" },
        //     ]
        // },
    ];
    // Get all leads flattened for table view
    const allLeads = useMemo(() => {
        if (!Array.isArray(data)) return []

        const allLeadsFlat = data.reduce((acc, stageData) => {
            const leads =
                stageData.leads?.map((c) => ({
                    ...c,
                    stagename: stageData.stage_name,
                })) || []
            return [...acc, ...leads]
        }, [])

        return filteredLeads || allLeadsFlat
    }, [data, filteredLeads])

    // Card/kanban payloads are stage groups (`leads[]`), not list rows. Rendering
    // them as rows produces empty "default" cells (often one row per stage).
    const isStageGroupedData =
        Array.isArray(data) &&
        data.length > 0 &&
        data.every((item) => item?.lead_id == null) &&
        data.some((item) => Array.isArray(item?.leads))

    // Determine the data to display based on filterData
    const dataToDisplay =
        tempFilterData !== null
            ? tempFilterData?.data
            : isStageGroupedData
                ? []
                : data
    // display length of data
    const hasDataToDisplay = dataToDisplay?.length > 0;
    // Calculate pagination values
    const isFiltered = tempFilterData !== null
    const totalItems = isFiltered ? tempFilterData?.total_count : totalModuleDataCount
    const pageCount = Math.ceil(totalModuleDataCount / limit)

    const handleSelectItems = (checked, selectType, itemId = null) => {
        if (selectType && !itemId) {
            if (!checked) {
                setSelectedItems([])
                setShowMultiItemChangeBar(false)
                return
            }
            const items = dataToDisplay.map(c => c.lead_id)
            setSelectedItems(items)
        } else {
            if (!checked) {
                if (selectedItems?.length === 1) {
                    setSelectedItems([])
                    setShowMultiItemChangeBar(false)
                    return
                }
                setSelectedItems(prev => prev.filter(c => c !== itemId))
            } else if (checked && itemId) {
                setSelectedItems(prev => [...prev, itemId])
                setShowMultiItemChangeBar(true)
            }
        }
        setShowMultiItemChangeBar(true)
    }

    const handleBulkUpdate = async (action) => {
        try {
            setLoading(true)
            const payload = {
                customer_id: customerId,
                user_login_id: loginUserId,
                module_name: `${module_name}s`,
                pipeline_id: pipeline_id,
                action: action,
                field: action === "update" ? fieldData?.fieldId : null,
                field_value: action === 'update' ? fieldData?.fieldValue : null,
                module_ids: selectedItems
            }
            const res = await PostRequest('common/bulkUpdate', payload, false, { headers }, extras)
            if (res.success === false || res.status === 'fail') {
                toast.error(res.message)
                setLoading(false)
                setShowBulkUpdateModal(false)
                setFieldData(null)
                return
            }
            if (action === "export") {
                downloadCSV(`${module_name}s`, res.data)
            }
            setShowDeleteModal(false)
            setShowBulkUpdateModal(false)
            setSelectedItems([])
            setFieldData(null)
            if (currAdvFilter === "apply") {
                fetchTemporaryFilterData(applyFilterDataParams?.applyFilterData)
            } else {
                refetchData()
            }
            setLoading(false)
            setShowMultiItemChangeBar(false)
            toast.success(res.message)
        } catch (error) {
            return
        }
    }

    useEffect(() => {
        setSelectedItems([]);
        setShowMultiItemChangeBar(false);
    }, [offset, limit]);

    // for calling
    const handleGlobalCallChange = () => {
        setGlobalDiller(false);
        setModuleId(null)
    };

    const checkTwilio = async () => {
        if (isCheckingTwilio) return;
        setIsCheckingTwilio(true);
        try {
            const res = await checkTwilioIntegration(customerId, headers, extras)
            if (res.status === "fail" || res.success === false) {
                setShowTwilioModal(true);
            }
            if (res.status === "success") {
                setGlobalDiller(true);
            }

        } catch (error) {
            console.error(error)
        } finally {
            setIsCheckingTwilio(false);
        }
    }

    const effectivePageCount = isFiltered
        ? Math.ceil((tempFilterData?.total_count || 0) / limit) || 0
        : pageCount


    const currPageItems = dataToDisplay?.length
    const displayStartItem = totalItems === 0 ? 0 : offset * limit + 1
    const displayEndItem = totalItems === 0 ? 0 : Math.min(offset * limit + limit, totalItems)

    function totalBudget(array) {
        try {
            const parsedData = JSON.parse(array)
            const totalBudget = parsedData.reduce((total, item) => {
                return total + (parseFloat(item.budget) || 0)
            }, 0)
            return totalBudget
        } catch (error) {
            return 0
        }
    }

    // Get budget color based on value
    const getBudgetColor = (budgetValue) => {
        if (budgetValue < 10000) {
            return "#ffdfba" // Orange for less than 10,000
        } else if (budgetValue < 50000) {
            return "#d8dbff" // Purple for less than 50,000
        } else {
            return "#ace9ce" // Green for 50,000 and above
        }
    }

    // Get lead status capsule color
    const getLeadStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "lost":
                return { backgroundColor: "#ffd1d1", color: "#d63031" } // Light red background, dark red text
            case "inprogress":
                return { backgroundColor: "#d1e8ff", color: "#0984e3" } // Light blue background, dark blue text
            case "won":
                return { backgroundColor: "#d1f7d1", color: "#00b894" } // Light green background, dark green text
            case "new":
                return { backgroundColor: "#fff4d1", color: "#fdcb6e" } // Light yellow background, dark yellow text
            default:
                return { backgroundColor: "#f1f3f4", color: "#636e72" } // Light gray background, dark gray text
        }
    }
    const getDate = (dated) => {
        const date = new Date(dated)
        let formattedDate
        if (date) {
            const day = String(date.getDate()).padStart(2, "0")
            const month = String(date.getMonth() + 1).padStart(2, "0")
            const year = date.getFullYear()
            formattedDate = `${day}/${month}/${year}`
        }
        return formattedDate
    }
    // Get field display value for table view
    const getFieldValue = (data, field) => {
        switch (field) {
            case "name":
                return data.contact_full_name || "-"
            case "phone":
                return <span
                    onClick={() => {
                        if (!data?.contact_phone) return
                        !showtwilioModal && setModuleId(data?.lead_id);
                        setCallingTo(loadPhoneNumber(data?.contact_phone));
                        checkTwilio();
                    }}
                    style={{ cursor: data?.contact_phone ? "pointer" : 'default' }}
                >
                    {loadPhoneNumber(data?.contact_phone)}
                </span>
            case "email":
                return (
                    (
                        <>
                            <i
                                className="fa-solid fa-envelope"
                                style={{ color: "black" }}
                            ></i>{" "}
                            {data.contact_email}
                        </>
                    ) || "-"
                )
            case "expected_closure_date":
                return data.expected_closure_date
                    ? getDate(data.expected_closure_date)
                    : "-"
            // case "followup_date":
            //   return lead.followup_date ? getDate(lead.followup_date) : "-"
            case "requirement":
                return (
                    { value: data.requirement || "N/A", length: data.requirement?.length } || "-"
                )
            case "pipeline_stage_name":
                return data.stage_name || "-"
            case "stagename":
                return data.stagename || "-"
            case "service":
                return data.service || "-"
            case "source":
                return (
                    { value: data.source_title, length: data.source_title?.length } || "-"
                )
            // case "expected_closure_time":
            //   return lead.expected_closure_time || "-"
            // case "followup_time":
            //   return lead.followup_time || "-"
            case "lead_status":
                return data.lead_status || "-"
            case "lead_owner":
                return data.lead_owner_name || "-"
            case "followup_created_on":

                const createdAt = data.followup_date || ""
                const time = data.followup_time || ""
                const formattedDate = formatDate(createdAt)
                const formattedTime = formatTime(time.split(" ")[0])
                return (
                    <div style={{ display: "flex", alignItems: 'center', gap: 3 }}>
                        <span>{formattedDate || "-"}</span>
                        {formattedTime ? (
                            <span style={{ fontSize: "0.8rem", color: "#6c757d", lineHeight: 0.5 }}>
                                {formattedTime}
                            </span>
                        ) : null}
                    </div>
                )
            case "followup_taken_by":
                return data.followup_taken_by || "-"
            case "created_on": {
                const createdAt = data.created_at || ""
                const [datePart, timePart] = createdAt.split(" ")
                const formattedDate = formatDate(datePart)
                const formattedTime = formatTime(timePart)
                return (
                    <div style={{ display: "flex", alignItems: 'center', gap: 3 }}>
                        <span>{formattedDate || "-"}</span>
                        {formattedTime ? (
                            <span style={{ fontSize: "0.8rem", color: "#6c757d", lineHeight: 0.5 }}>
                                {formattedTime}
                            </span>
                        ) : null}
                    </div>
                )
            }
            default:
                return "-"
        }
    }

    function loadPhoneNumber(contact_phone) {
        if (!contact_phone) return "-"

        try {
            const parsed = JSON.parse(contact_phone)

            if (Array.isArray(parsed) && parsed.length > 0) {
                const { country_code, phone } = parsed[0]

                if (country_code && phone) {
                    return (
                        <span style={{ whiteSpace: "nowrap", letterSpacing: '0.25px', }}>
                            +{country_code} {maskContactNumber(customer, phone)}
                        </span>
                    )
                }
            }
        } catch (e) {
            return "-"
        }

        return "-"
    }


    // Reorder visible columns to place lead_status and budget after requirement
    // Reorder visible columns to place pipelineName, lead_status and budget after requirement
    const getOrderedVisibleColumns = () => {
        const loweredCaseCols = visibleColumns.map((c) => c?.toLowerCase()?.split(" ")?.join("_"))
        const baseColumns = [...loweredCaseCols]

        // Remove pipelineName, lead_status and budget if they exist
        const filteredColumns = baseColumns.filter(
            (col) =>
                col !== "pipeline_stage_name" && col !== "lead_status" && col !== "budget"
        )

        // Find requirement index
        const requirementIndex = filteredColumns.indexOf("requirement")

        // Insert pipelineName, lead_status and budget after requirement
        if (requirementIndex !== -1) {
            // Add pipelineName after requirement
            filteredColumns.splice(requirementIndex + 1, 0, "pipeline_stage_name")
            // Add lead_status after pipelineName
            filteredColumns.splice(requirementIndex + 2, 0, "lead_status")
            // Add budget after lead_status
            filteredColumns.splice(requirementIndex + 3, 0, "budget")
        } else {
            // If requirement not found, add at the end
            filteredColumns.push("pipeline_stage_name", "lead_status", "budget")
        }

        return filteredColumns
    }

    const orderedVisibleColumns = getOrderedVisibleColumns()

    // Get field display name for table headers
    const getFieldDisplayName = (field, index) => {
        const fieldNames = {
            name: "Name",
            phone: "Phone",
            email: "Email",
            budget: "Budget",
            lead_owner: "Lead Owner",
            expected_closure_date: "Expected Closure Date",
            // followup_date: "Follow Up Date",
            requirement: "Requirement",
            stagename: "Pipeline Stage Name", // Add this line
            pipeline_stage_name: "Pipeline Stage Name", // Also add this for consistency
            service: "Service",
            source: "Source",
            // expected_closure_time: "Expected Closure Time",
            followup_created_on: "Followup Created On",
            followup_taken_by: "Followup Taken By",
            lead_status: "Lead Status",
            created_on: "Created On"
        }
        return fieldNames[field] || field
    }

    if (tempFilterData?.data !== null && offset !== 0 && dataToDisplay?.length === 0) {
        setOffset(0);
    }

    const tableHeader = () => (
        <thead style={{ zIndex: 100, }} >
            <tr style={{ textAlign: "start" }}>
                <th style={{ position: "sticky", left: 0 }}>
                    <input
                        type="checkbox"
                        style={{
                            width: "14px",
                            height: "14px",
                            cursor: "pointer",
                            accentColor: "#007bff"  // Modern browsers including Safari 15+
                        }}
                        checked={
                            dataToDisplay?.length > 0 &&
                            selectedItems?.length === dataToDisplay?.length
                        }
                        onChange={(e) => handleSelectItems(e.target.checked, true)}
                    />
                </th>
                {orderedVisibleColumns.map((field) => (
                    <th
                        key={field}
                        style={{
                            position:
                                field === "name" ? "sticky" : "static",
                            left: field === "name" ? "40px" : "auto",
                            backgroundColor:
                                field === "name"
                                    ? "white"
                                    : "transparent",
                            minWidth:
                                field === "name" ? "200px" : "auto",
                        }}
                    >
                        {getFieldDisplayName(field)}{" "}
                        <i
                            className="fa-solid fa-sort"
                            style={{ fontSize: "0.6rem" }}
                        ></i>
                    </th>
                ))}
                {
                    data?.lead_status?.toLowerCase() !== "won" &&
                    <th></th>
                }
            </tr>

        </thead>
    )

    const tableBody = () => (
        dataToDisplay?.map((data, index) => {
            const budgetValue = totalBudget(data.product_services)
            const budgetColor = getBudgetColor(budgetValue)
            const statusColor = getLeadStatusColor(data?.lead_status)

            return (
                <tr
                    key={data.lead_id}
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                    className={String(data?.lead_id) === String(highlightId) ? "blink-row" : ""}
                >
                    <td
                        style={{
                            position: "sticky",
                            left: 0,
                            backgroundColor: "white",
                            zIndex: 90,
                        }}
                    >
                        {
                            <input
                                type="checkbox"
                                style={{
                                    width: "14px",
                                    height: "14px",
                                    cursor: "pointer",
                                    accentColor: "#007bff"
                                }}
                                checked={selectedItems?.includes(data.lead_id)}
                                onChange={(e) => handleSelectItems(e.target.checked, false, String(data.lead_id))}
                            />
                        }
                    </td>
                    {orderedVisibleColumns.map((field) => (
                        < td
                            key={field}
                            style={{
                                cursor:
                                    field === "name" && "pointer",
                                fontWeight:
                                    field === "name" ? 600 : "normal",
                                color:
                                    field === "phone"
                                        ? "#2184ff"
                                        : "inherit",
                                width:
                                    field === "name" ? "16%" : "auto",
                                textTransform:
                                    field === "name"
                                        ? "capitalize"
                                        : "inherit",
                                position:
                                    field === "name"
                                        ? "sticky"
                                        : "static",
                                left:
                                    field === "name" ? "40px" : "auto",
                                backgroundColor:
                                    field === "name"
                                        ? "white"
                                        : "transparent",
                                minWidth:
                                    field === "name"
                                        ? "21ch"
                                        : "auto",
                                maxWidth:
                                    field === "name"
                                        ? "21ch"
                                        : field === "requirement" ? "280px" : "auto",
                                overflow:
                                    field === "name" || field === "requirement" ? "hidden" : "visible",
                                textOverflow:
                                    field === "name" || field === "requirement" ? "ellipsis" : "clip",
                                whiteSpace:
                                    field === "name" || field === "phone" || field === "email"
                                        ? "nowrap"
                                        : field === "requirement"
                                            ? "nowrap"
                                            : "normal",
                                textWrap: field === "lead_owner" && "nowrap"
                            }}
                            onClick={() =>
                                field === "name" &&
                                navigateToCrmDetail(navigate, location, detailPagePath, {
                                    id: data.lead_id,
                                    pipeline_id: pipeline_id,
                                })
                            }
                        >
                            {field === "name" ? (
                                <div
                                    style={{
                                        width: "21ch",
                                        maxWidth: "21ch",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                    title={getFieldValue(data, field)}
                                >
                                    {getFieldValue(data, field)}
                                </div>
                            ) : field === "budget" ? (
                                <div
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: budgetColor,
                                        color: "black",
                                        borderRadius: "12px",
                                        padding: "4px 12px",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        minWidth: "80px",
                                        textAlign: "center",
                                        height: "20px",
                                    }}
                                >
                                    ₹{budgetValue.toLocaleString()}
                                </div>
                            ) : field === "lead_status" ? (
                                <div
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor:
                                            statusColor.backgroundColor,
                                        color: statusColor.color,
                                        borderRadius: "12px",
                                        padding: "4px 12px",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        minWidth: "80px",
                                        textAlign: "center",
                                        height: "20px",
                                    }}
                                >
                                    {getFieldValue(data, field)}
                                </div>
                            ) : field === "requirement" ? (
                                getFieldValue(data, field)?.length > 35 ? (
                                    <Tooltip
                                        title={getFieldValue(data, field)?.value}
                                        arrow
                                        placement="bottom"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#7a3a5e",
                                                    color: "white",
                                                },
                                            },
                                            arrow: {
                                                sx: {
                                                    color: "#7a3a5e",
                                                },
                                            },
                                        }}
                                    >
                                        <div
                                            style={{
                                                cursor: "pointer",
                                                display: "inline-block",
                                                maxWidth: "100%",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {getFieldValue(data, field)?.value}
                                        </div>
                                    </Tooltip>
                                ) : (
                                    <div
                                        style={{
                                            display: "inline-block",
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {getFieldValue(data, field)?.value}
                                    </div>
                                )
                            ) :
                                field === "source" ? (
                                    getFieldValue(data, field)?.length > 20 ? (
                                        <Tooltip
                                            title={getFieldValue(data, field).value}
                                            arrow
                                            placement="bottom"
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        fontSize: "0.8rem",
                                                        backgroundColor: "#7a3a5e",
                                                        color: "white",
                                                    },
                                                },
                                                arrow: {
                                                    sx: {
                                                        color: "#7a3a5e",
                                                    },
                                                },
                                            }}
                                        >
                                            <div
                                                style={{
                                                    cursor: "pointer",
                                                    display: "inline-block",
                                                    maxWidth: "100%",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {getFieldValue(data, field).value?.slice(0, 30)}...
                                            </div>
                                        </Tooltip>
                                    ) : (
                                        <div
                                            style={{
                                                display: "inline-block",
                                                maxWidth: "100%",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {getFieldValue(data, field)?.value}
                                        </div>
                                    )
                                ) :
                                    <span>{getFieldValue(data, field)}</span>
                            }
                        </td>
                    ))}

                    <td
                        style={{
                            "--pad": "10px",
                            paddingRight: "var(--pad) !important",
                            paddingLeft: "var(--pad) !important",
                            zIndex: openRow === data.id ? 95 : 90,
                        }}
                    >
                        <div>
                            <Dropdown
                                as="div"
                                className="dropdownsWithoutToggle"
                                onToggle={(isOpen) =>
                                    setOpenRow(isOpen ? data.id : null)
                                }
                            >
                                <Dropdown.Toggle
                                    as={Nav.Link}
                                    className="header-link"
                                >
                                    {
                                        data?.lead_status?.toLowerCase() !== "won" &&
                                        <FontAwesomeIcon
                                            icon={faEllipsisVertical}
                                            style={{
                                                fontSize: "15px",
                                                width: "20px",
                                                color: "#536485",
                                            }}
                                        />
                                    }
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                    align={"end"}
                                    style={{
                                        width: "8rem",
                                        inset: "0px auto auto 0px",
                                        boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                        position: "absolute",
                                        marginTop: "-22px",
                                        marginRight: "33px",
                                        minWidth: "3rem",
                                    }}
                                >
                                    <Dropdown.Item
                                        style={{
                                            fontSize: "12px",
                                            padding: "4px 21px",
                                        }}
                                        className="d-flex align-items-center btn"
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            if (!canEdit_canDownload) {
                                                toast.warning("Your account has read-only access across this shared pipeline.")
                                                return
                                            }
                                            onEditLead(data.lead_id)
                                        }}
                                    >
                                        Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        style={{
                                            fontSize: "12px",
                                            padding: "4px 21px",
                                        }}
                                        className="d-flex align-items-center btn"
                                        onClick={(e) => {
                                            if (!canEdit_canDownload) {
                                                toast.warning("Your account has read-only access across this shared pipeline.")
                                                return
                                            }
                                            e.stopPropagation()
                                            onDeleteLead(data.lead_id)
                                        }}
                                    >
                                        Delete
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </td>
                </tr>
            )
        }))

    return (
        <>
            <Container
                fluid
                style={{
                    fontFamily: "'Poppins', sans-serif",
                    height: "calc(100vh - 12rem)",
                    padding: 0,
                    animation: "cardEntry 1s ease-out forwards",
                }}
                className="mt-3 p-0"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        width: "100%",
                        borderRadius: "7px"
                    }}
                    className='position-relative container-table'
                >
                    <TableWrapper
                        isLoading={Boolean(isDataLoading || tempFilterDataLoading)}
                        hasData={hasDataToDisplay}
                        tableHeader={tableHeader()}
                        tableBody={tableBody()}
                        displayStartItem={displayStartItem}
                        displayEndItem={displayEndItem}
                        totalItems={totalItems}
                        currPageItems={currPageItems}
                        offset={offset}
                        setOffset={setOffset}
                        limit={limit}
                        setLimit={setLimit}
                        handlePageChange={handlePageChange}
                        effectivePageCount={effectivePageCount}
                        columnLabels={orderedVisibleColumns}
                        showMultiItemChangeBar={showMultiItemChangeBar}
                        setShowMultiItemChangeBar={setShowMultiItemChangeBar}
                        setSelectedItems={setSelectedItems}
                        module_name={module_name}
                        onClickBulkUpdate={() => {
                            if (!mainGrant?.isEdit) {
                                toast.warning("You are not authorized for this action!")
                                return
                            }
                            if (!canEdit_canDownload) {
                                toast.warning("Your account has read-only access across this shared pipeline.")
                                return
                            }
                            setShowBulkUpdateModal(true)
                        }}
                        onDelete={() => {
                            if (!mainGrant?.isDelete) {
                                toast.warning("You are not authorized for this action!")
                                return
                            }
                            if (!canEdit_canDownload) {
                                toast.warning("Your account has read-only access across this shared pipeline.")
                                return
                            }
                            setShowDeleteModal(true)
                        }}
                        onExport={() => {
                            if (!mainGrant?.isExport) {
                                toast.warning("You are not authorized for this action!")
                                return
                            }
                            if (!canEdit_canDownload) {
                                toast.warning("Your account has read-only access across this shared pipeline.")
                                return
                            }
                            handleBulkUpdate("export")
                        }}
                        onWhatsapp={() => {
                            if (!selectedItems?.length) {
                                toast.warning("Please select at least one item.")
                                return
                            }
                            setShowWhatsappModal(true)
                        }}
                        onEmail={() => {
                            if (!selectedItems?.length) {
                                toast.warning("Please select at least one item.")
                                return
                            }
                            setShowEmailModal(true)
                        }}
                    />
                </div>
            </Container>
            {
                globalDiller && (
                    <GlobalCallModal
                        isOpen={globalDiller}
                        customerId={customerId}
                        loginUserId={loginUserId}
                        phoneNumber={callingTo}
                        onClose={handleGlobalCallChange}
                        module_name={module_name}
                        module_id={module_id}
                    />
                )
            }

            {/* {twilio modal} */}
            {
                showtwilioModal && (
                    <TwilioIntegrationForm
                        isOpen={showtwilioModal}
                        onClose={() => setShowTwilioModal(false)}
                    />
                )
            }

            <BulkUpdateModal
                show={showBulkUpdateModal}
                onHide={() => setShowBulkUpdateModal(false)}
                onSubmit={() => handleBulkUpdate('update')}
                headers={headers}
                extras={extras}
                selectedIds={selectedItems}
                fieldData={fieldData}
                setFieldData={setFieldData}
                columnForBulkUpdate={bulkUpdateColumns}
                loading={loading}
            />

            <DeleteModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={() => handleBulkUpdate('delete')}
                isLoading={loading}
                message="Are you sure you want to delete selected items?"
            />

            {
                showWhatsappModal && (
                    <WhatsappModal
                        whatsappModalOpen={showWhatsappModal}
                        setWhatsAppModalOpen={setShowWhatsappModal}
                        id={selectedItems}
                        module_name={`${module_name}s`}
                    />
                )
            }

            <EmailModal
                show={showEmailModal}
                onClose={() => setShowEmailModal(false)}
                id={selectedItems}
                pipelineId={pipeline_id}
                customerId={customerId}
                loginId={loginUserId}
                headers={headers}
                extras={extras}
                module_name={`${module_name}s`}
            />


        </>

    )
}

const styles = {
    lastdStyle: {
        padding: "0 !important",
    },
    lastactiontd: {
        padding: "0px !important",
    },
    lastactionTh: {
        padding: "0px !important",
    }
}